module.exports = __webpack_public_path__ + "img/icon-triangle.9b92ff31.svg";